/* file description */

import type { UseSetVal } from './type';
import _ from 'lodash';
import { COLUMN_FROM } from '../../../effects/consts';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { Api as FetchAPI } from '@cui/req';

export const useSetVal: UseSetVal = ({ onChange, field, columnFrom, form, treeData, config, moduleInfo }) => {
  const { emitEvent } = config.metaStore || {};
  const selectTree = (val: string | number, isOnchange = true) => {
    const { showFields = [], options = [] } = field.options || {};

    const SelectedRef = treeData.find((item: any) => item.value === val);
    const { treeId, dataKey, value } = field?.options;
    const handleLinkData = (SelectedRef) => {
      options.forEach((item: { moduleField: any; linkField: any }) => {
        const values: Record<any, any> = {};
        if (columnFrom === COLUMN_FROM.FORM) {
          values[item.moduleField] = SelectedRef[item.linkField];
          form.setFieldsValue(values);
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          const tableKey = config.rowIndex;
          values[tableKey] = {};
          values[tableKey][item.moduleField] = SelectedRef[item.linkField];
          form.setFieldsValue(values);
        }
        emitEvent && emitEvent({ value: SelectedRef[item.linkField], moduleName: moduleInfo.handle, fieldName: item.moduleField, rowIndex: config.rowIndex, touchConfig: 'change' });
      });
      // 联动展示字段
      showFields.forEach((item: { key: any; realLabel: any }) => {
        const values: Record<any, any> = {};
        const setName = `${field.name}_LINK_${item?.key}`;
        if (columnFrom === COLUMN_FROM.FORM) {
          values[setName] = SelectedRef[item?.key];
          form.setFieldsValue(values);
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          const tableKey = config.rowIndex;
          values[tableKey] = {};
          values[tableKey][setName] = SelectedRef[item?.key];
          form.setFieldsValue(values);
        }
      });
    };
    const getCppyData = async () => {
      const reqData = {
        page: 1,
        version: '0',
        namespaceID: treeId,
        moduleID: dataKey,
        filter: `${value} in ('${val}')`,
        limit: 10,
        pageCursor: '',
        incPageNavigation: true,
        incTotal: true,
        sort: '',
      };
      const res = await getModuleRecordListCache(FetchAPI, treeId, dataKey, reqData);
      const newSelected: Record<string, any> = {};
      res?.set?.[0]?.values.forEach(valueItem => {
        const { name = '', value = '' } = valueItem ?? {};
        newSelected[name] = value;
      });
      handleLinkData(newSelected);
    };
    if (val && showFields.length) {
      getCppyData();
    }
    if (SelectedRef) {
      handleLinkData(SelectedRef);
    }
    if (field?.options?.isMulti) {
      if (_.isArray(val)) {
        const arrVal = val.join(',');
        onChange?.(arrVal);
      } else {
        isOnchange && onChange?.(val);
      }
    } else {
      isOnchange && onChange?.(val);
    }
  };
  return {
    selectTree,
  };
};
